import type { AuditUser } from '../types';

export interface AuditableRecord {
  created_by: AuditUser | null;
  updated_by: AuditUser | null;
  created_at: string;
  updated_at: string;
}

/**
 * Read-only "Created by / Last modified by" footer for edit modals.
 * Both lines show the user's full name (or em-dash if null) and the
 * relevant timestamp formatted in the user's locale.
 */
export const AuditMetadata = ({ record }: { record: AuditableRecord }) => (
  <div className="border-t border-gray-200 pt-3 mt-3 space-y-1 text-xs text-gray-500">
    <div>
      <span className="font-semibold text-gray-600">Created by:</span>{' '}
      {record.created_by?.full_name ?? '—'}
      <span className="text-gray-400"> · {new Date(record.created_at).toLocaleString()}</span>
    </div>
    <div>
      <span className="font-semibold text-gray-600">Last modified by:</span>{' '}
      {record.updated_by?.full_name ?? '—'}
      <span className="text-gray-400"> · {new Date(record.updated_at).toLocaleString()}</span>
    </div>
  </div>
);

export default AuditMetadata;
